module.exports = __webpack_public_path__ + "img/offical2.19892667.jpg";